import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import App from "apps/messenger/containers/App";
import getApolloClient from "shared/util/getApolloClient";
import { SmsWallProvider } from "apps/messenger/hooks/useSmsWall";
import SmsConvoWall from "apps/messenger/components/SmsConvoWall";

const Messenger = () => (
	<ApolloProvider client={getApolloClient()}>
		<SmsWallProvider>
			<SmsConvoWall />
			<App />
		</SmsWallProvider>
	</ApolloProvider>
);

export default Messenger;



// WEBPACK FOOTER //
// ./src/apps/messenger/index.js